{
  "version": 1,
  "asset_id": "227d5464-dad6-4186-9c53-0641bab8f60e",
  "project_id": "0fdb3b9c-5222-4717-8611-0aaf6da51cb4",
  "url": "/__l5e/assets-v1/227d5464-dad6-4186-9c53-0641bab8f60e/50.V1.-SAK-Electric-Nov-22.6871-scaled.jpg",
  "r2_key": "a/v1/0fdb3b9c-5222-4717-8611-0aaf6da51cb4/227d5464-dad6-4186-9c53-0641bab8f60e/50.V1.-SAK-Electric-Nov-22.6871-scaled.jpg",
  "original_filename": "50.V1.-SAK-Electric-Nov-22.6871-scaled.jpg",
  "size": 413189,
  "content_type": "image/jpeg",
  "created_at": "2026-06-16T09:42:28Z"
}
